import "../../styles/about-us.css";
import { useEffect, useRef, useState } from "react";
import AboutHero from "./aboutHero";
import AboutComponent from "./aboutComponent";
import AboutVision from "./aboutVision";
import AboutValues from "./aboutValues";
import Leadership from "./aboutLeadership";

function AboutUs() {
  const ref = useRef(null);
  const valuesRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [valuesVisible, setValuesVisible] = useState(false);

  const scrollToView = () => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );

    const currentRef = ref.current;

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setValuesVisible(entry.isIntersecting),
      { threshold: 0.5 }
    );

    const currentRef = valuesRef.current;

    if (valuesRef.current) {
      observer.observe(valuesRef.current);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div>
      <AboutHero scroll={scrollToView}/>
      <AboutComponent />
      <AboutVision ref={ref} visible={visible}/>
      <AboutValues ref={valuesRef} visible={valuesVisible} />
      <Leadership />
    </div>
  );
}

export default AboutUs;
